import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { PANEL_SCROLL_THRESHOLD } from '../Model/Model';
import { getPanelHeader } from './EventMonitoringCommon';

/**
 * @Author      Karen Yunuen Pozos Arias
 * @JobTitle    Full Stack
 * @Email       kpozos@ibl.mx
 *
 * Expanded view of a panel: the events the panel already read, in a list that reads the next page of the
 * panel once it is scrolled near its bottom, the same way the panel does.
 */
const ExpandPanelModalApp = ({ panel, feed, onLoadMore }) => {
    const { t } = useTranslation();
    const bodyRef = useRef(null);

    const header = getPanelHeader(panel, t);
    const panelEvents = feed.events;

    /**
     * Reads the next page once the list is near its bottom. A list whose events do not fill it
     * has no scroll, so it reads the next page right away.
     */
    const loadMoreIfNeeded = () => {
        const body = bodyRef.current;
        if (!body || !feed.loaded || !feed.hasMore || feed.loading) return;

        const { scrollTop, scrollHeight, clientHeight } = body;
        if (scrollHeight - scrollTop <= clientHeight + PANEL_SCROLL_THRESHOLD) onLoadMore(panel);
    };

    // Each page can leave the list without scroll //
    useEffect(loadMoreIfNeeded, [feed]);

    return {
        t,
        header,
        panelEvents,
        bodyRef,
        loadMoreIfNeeded,
        // The empty state is shown only once the panel knows it has no events //
        showEmpty: feed.loaded && !feed.loading && panelEvents.length === 0,
        loading: !feed.loaded || feed.loading,
    };
};

export default ExpandPanelModalApp;
